import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import AdminHeader from "./AdminHeader";
import AdminNavigation from "./AdminNavigation";
import AdminFooter from "./AdminFooter";
import { ToastContainer, toast } from "react-toastify";
import {
  submitFormData,
  getSurveyFormQuestion,
} from "../../Utils/adminFunctions";
import * as Constant from "../../Utils/constants";
import { FormBuilder } from "react-formio";

let AdminEditSurveyQuestion = () => {
  const navigate = useNavigate();
  const { surveyID } = useParams();
  const [formJson, setFormJson] = useState([]);
  const [isDisabledBtn, setIsDisabledBtn] = useState("disabled");
  const [participantQualification, setParticipantQualification] =
    useState("no");
  const componentRef = useRef({});
  const { current: form } = componentRef;
  useEffect(() => {
    getSurveyQuestion();
  }, []);
  const handleChange = (e) => {
    form.schema = JSON.stringify(e.components, null, 4);
    setIsDisabledBtn("");
  };
  async function getSurveyQuestion() {
    const response = await getSurveyFormQuestion(surveyID);
    if (response.status == "success") {
      setFormJson(JSON.parse(response.getFormJson));
      setParticipantQualification(response.getParticipantQualificationStatus);
    }
  }
  const saveFormSchema = async () => {
    if (form.schema.length <= 1917) {
      toast.warning(Constant.REQUIRED_FIELDS, { autoClose: 1500 });
      return false;
    }
    const result1 = form.schema.replace(/true/g, '"true"'); // replace true
    const result2 = result1.replace(/false/g, '"false"'); // replace false
    const finalSchema = result2.replace(/null/g, '"null"'); // replace false
    const bodyFormData = new FormData();
    bodyFormData.append("survey_id", surveyID);
    bodyFormData.append("form_json", finalSchema);
    const response = await submitFormData("addSurveyQuestion", bodyFormData);
    if (response.status == "success") {
      setTimeout(() => {
        toast.success(response.message, { autoClose: 1500 });
      }, 500);
      navigate("/AdminSurveyDetails/" + surveyID);
    } else {
      toast.warning(response.message, { autoClose: 1500 });
    }
  };
  return (
    <div>
      <div className="wrapper">
        <div>
          
          <AdminHeader />
          <AdminNavigation />
          <div className="content-wrapper">
            <div className="content-header"></div>
            <section className="content">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-12">
                    <div className="card card-default">
                      <div className="card-header">
                        <div className="card-tools1">
                          <div className="row">
                            <div className="col-md-6 text-left">
                              {participantQualification === "yes" && (
                                <>
                                  <Link
                                    to={
                                      "/AdminEditParticipantQualification/" +
                                      surveyID
                                    }
                                    className="btn btn-sm custom-btn-primary"
                                  >
                                    <i className="fa fa-edit"></i> Edit
                                    Participant Qualification
                                  </Link>
                                </>
                              )}
                            </div>
                            <div className="col-md-6 text-right">
                              <Link
                                to={"/AdminSurveyDetails/" + surveyID}
                                className="btn btn-sm custom-btn-primary"
                              >
                                <i className="fa fa-arrow-left"></i> Back
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="card-body">
                        <FormBuilder
                          options={{
                            builder: {
                              layout: false,
                              premium: false,
                              basic: {
                                default: true,
                                components: {
                                  password: false,
                                  radio: true,
                                  select: false,
                                  button: false,
                                },
                              },
                              advanced: {
                                default: false,
                                components: {
                                  email: false,
                                  url: false,
                                  phoneNumber: false,
                                  tags: false,
                                  day: false,
                                  currency: false,
                                  time: false,
                                  address: false,
                                  datetime: true,
                                  survey: true,
                                  signature: false,
                                },
                              },
                              data: {
                                default: false,
                                components: {
                                  htmlelement: true,
                                  hidden: false,
                                  content: true,
                                  container: false,
                                  datamap: false,
                                  datagrid: false,
                                  tree: false,
                                  editgrid: false,
                                },
                              },
                            },
                          }}
                          form={{ display: "form", components: formJson }}
                          type="danger"
                          onChange={(e) => {
                            handleChange(e);
                          }}
                        />
                        <button
                          type="button"
                          name="save"
                          id="save"
                          className="btn custom-btn-primary btn-sm  pull-right"
                          onClick={saveFormSchema}
                          disabled={isDisabledBtn}
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>

          <AdminFooter />
        </div>
      </div>
    </div>
  );
};

export default AdminEditSurveyQuestion;
